module.exports = __webpack_public_path__ + "static/media/014.0a210b08.jpg";